module.exports = __webpack_public_path__ + "static/media/banner_en.6b7b080e.png";